export const LOG_IN_LABEL = 'Log in';
export const SIGN_UP_LABEL = 'Sign up';
export const LOG_IN_HREF = '/signin';
export const SIGN_UP_HREF = '/signup';
